import React from 'react';
import Cartoon_Video from '../../assests/video/MetroAllTaxis24x7StanstedAirport.mp4';
import poster_video from '../../assests/images/image_premium1.png';

const VideoSec = () => {
    return (
        <div className='video_sec'>
            <video poster={poster_video} className='video_home_sec' controls>
                <source src={`${Cartoon_Video}`} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    )
}

export default VideoSec;